export default __webpack_public_path__ + "a4ae002eb717f88d07b256725816b52a.svg";